import { useSession } from 'next-auth/react'

export function useSessionInfo() {
  const session = useSession()

  return {
    trigger: session?.data?.trigger,
    isSignIn: session?.data?.type === 1 || !!session?.data?.user?.email,
    isAnonymousUser: session?.data?.type === 0 || !session?.data?.user?.email,
    sessionLoading: session?.status === 'loading',
    sessionAuthenticated: session?.status === 'authenticated',
    isVerified: !!session?.data?.user?.emailVerified,
    userId: session.data?.user.id || '',
    sessionData: session?.data,
    email: session?.data?.user?.email,
    userDateCreated: (session?.data?.user as any)?.date_created as Date | null,
  }
}
